import { render, staticRenderFns } from "./SafeVideo.vue?vue&type=template&id=2ef2fa59&scoped=true&"
import script from "./SafeVideo.vue?vue&type=script&lang=js&"
export * from "./SafeVideo.vue?vue&type=script&lang=js&"
import style0 from "./SafeVideo.vue?vue&type=style&index=0&id=2ef2fa59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2fa59",
  null
  
)

export default component.exports